import React from 'react';
import styles from './UseSelector.module.scss';
import { Use } from '../../../types/projectDocumentation';
import { ArrowLeft } from 'lucide-react';
import CheckIcon from '../../../assets/iconsTsx/CheckIcon.tsx';

interface UseSelectorProps {
  uses: Use[];
  selectedUse: string | null;
  onSelect: (useId: string) => void;
  onBack: () => void;
}

const UseSelector: React.FC<UseSelectorProps> = ({
  uses,
  selectedUse,
  onSelect,
  onBack
}) => {
  const handleUseSelect = (useId: string) => {
    onSelect(useId);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h2 className={styles.title}>Selecciona el uso</h2>
          <p className={styles.description}>
            Elige el uso principal de tu anteproyecto
          </p>
        </div>
        <button className={styles.backButton} onClick={onBack}>
          <ArrowLeft size={16} />
          Volver
        </button>
      </div>

      <div className={styles.usesGrid}>
        {uses.map((use) => (
          <div
            key={use.id}
            className={`${styles.useCard} ${
              selectedUse === use.id ? styles.selected : ''
            }`}
            onClick={() => handleUseSelect(use.id)}
          >
            <div className={styles.useIcon}>
              <div className={styles.iconPlaceholder}>
                {use.name.charAt(0).toUpperCase()}
              </div>
            </div>
            <h3 className={styles.useName}>{use.name}</h3>
            {selectedUse === use.id && (
              <div className={styles.checkmark}>
                <CheckIcon className={styles.checkIcon} />
              </div>
            )}
          </div>
        ))}
      </div>

      {uses.length === 0 && (
        <div className={styles.emptyState}>
          <p>No hay usos disponibles</p>
        </div>
      )}

    </div>
  );
};

export default UseSelector;
